import React, { useEffect, useState } from "react"
import { Link } from "react-router"
import { useTranslation } from "react-i18next"
import { Dropdown } from "react-bootstrap"

import DeleteModal from "pages/parts/DeleteModal"
import { DELETE, GET, httpOk } from "helpers/api"
import { formatDate } from "helpers/helpers"

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteId, setDeleteId] = useState(0)

	async function getData() {
		const response = await GET("/motivations", {}, { loader: true })
		if (httpOk(response)) setData(response.data.data || [])
	}

	async function deleteItem() {
		const response = await DELETE(`/motivations/${deleteId}`, {}, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			setDeleteId(0)
			getData()
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					Мотивационные программы [{data.length}]
				</h4>
				<div className="d-flex">
					<Link className="btn-rounded btn btn-primary" to="/motivations/create">
						{t("create")}
					</Link>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: "33px" }} className="text-center">#</th>
									<th style={{ width: "25%" }}>{t("title")}</th>
									<th style={{ width: "25%" }}>{t("calculation_type")}</th>
									<th style={{ width: "50%" }}>{t("comment")}</th>
									<th style={{ minWidth: "170px" }} className="text-center">{t("period")}</th>
									<th style={{ minWidth: "100px" }} className="text-center">{t("status")}</th>
									<th style={{ minWidth: "33px" }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={item.id || index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td>{item.motivation_calculation_type_name}</td>
										<td className="td-ellipsis">{item.comment}</td>
										<td className="text-center">
											{formatDate(item.start_date)}
											{item.end_date ? ` - ${formatDate(item.end_date)}` : ""}
										</td>
										<td className="text-center">
											{!item.is_active &&
												<span className="bg-danger bg-border"></span>
											}
											{item.is_active &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${item.id || index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Link className="table-dropdown-item" to={`/motivations/update/${item.id}`}>
															<i className="uil-edit-alt"></i>
															{t("edit")}
														</Link>
														<div
															className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteId(item.id)
																setModalDelete(true)
															}}
														>
															<i className="uil-times"></i>
															{t("delete")}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
								{!data.length &&
									<tr>
										<td colSpan={7} className="text-center text-muted">Список пуст</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index
